/*
 * @Description 组件 IndexLeft 布局
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-page-left start -->
	<div class="index-page-left">
		
		<!-- 组件 进场情况 -->
        <IndApproach />
		
		<!-- 组件 各组人员 -->
        <IndGroupUser />
		
		<!-- 组件 设备数量 -->
        <IndDeviceStatistic />
        
        <!-- 组件 气体检测 -->
        <!--<IndLBGasDetect />-->
		
	</div>
	<!-- index-page-left end -->
</template>

/* JS */
<script>
	// 组件 进场情况
	import IndApproach from '@/components_index/IndexItems/IndApproach';
	// 组件 各组人员
	import IndGroupUser from '@/components_index/IndexItems/IndGroupUser';
	// 组件 设备数量
	import IndDeviceStatistic from '@/components_index/IndexItems/IndDeviceStatistic';
	// 组件 气体检测
	// import IndLBGasDetect from '@/components_index/IndexItems/IndLBGasDetect';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndexLeft",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 进场情况
        	IndApproach,
        	// 组件 各组人员
        	IndGroupUser,
        	// 组件 设备数量
        	IndDeviceStatistic,
        	// 组件 气体检测
        	// IndLBGasDetect,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>




// WEBPACK FOOTER //
// src/components_index/IndexPage/IndexLeft.vue